<template>
  <teleport to="body">
    <transition name="fade">
      <div
        v-if="value"
        class="location-modal-backdrop"
        @click.self="$emit('input', false)"
      >
        <div class="location-modal" @click.stop>
          <header class="modal-header">
            <h3>Select Location</h3>
            <button class="close-btn" @click="$emit('input', false)">
              ×
            </button>
          </header>

          <ul class="location-list">
            <li
              v-for="loc in locations"
              :key="loc.id"
              class="location-item"
              @click="select(loc)"
            >
              {{ loc.name }}
            </li>
          </ul>

          <footer class="modal-footer">
            <button class="cancel-btn" @click="$emit('input', false)">
              Cancel
            </button>
          </footer>
        </div>
      </div>
    </transition>
  </teleport>
</template>

<script>
export default {
  name: 'LocationModal',
  props: {
    value: { type: Boolean, required: true },
    locations: { type: Array, required: true }
  },
  mounted() {
    console.log('[LocationModal] mounted – visible:', this.value);
  },
  methods: {
    select(loc) {
      this.$store.dispatch('setCurrentLocation', { id: loc.id, name: loc.name });
      this.$emit('input', false); // Vue 2 v-model
    }
  }
};
</script>

<style scoped>
.location-modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}
.location-modal {
  background: #fff;
  border-radius: 8px;
  width: 340px;
  max-width: 90vw;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.2);
  overflow: hidden;
}
.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.5rem;
  border-bottom: 1px solid #e5e5e5;
}
.modal-header h3 { margin: 0; font-size: 1.25rem; }
.close-btn { background: none; border: none; font-size: 1.5rem; cursor: pointer; line-height: 1; }
.location-list { list-style: none; padding: 0; margin: 0; max-height: 45vh; overflow-y: auto; }
.location-item { padding: 0.9rem 1.5rem; cursor: pointer; transition: background 0.15s; }
.location-item:hover { background: #f0f8ff; }
.location-item + .location-item { border-top: 1px solid #eaeaea; }
.modal-footer { padding: 0.75rem 1.5rem; text-align: right; border-top: 1px solid #e5e5e5; }
.cancel-btn { padding: 0.4rem 1rem; background: #ddd; border: none; border-radius: 4px; cursor: pointer; }
.cancel-btn:hover { background: #ccc; }
.fade-enter-active, .fade-leave-active { transition: opacity 0.2s ease; }
.fade-enter-from, .fade-leave-to { opacity: 0; }
</style>